import {createAsyncComponent, DeferTiming} from '@shopify/react-async';

export type {Props as CodeMirrorEditorProps} from './CodeMirrorEditor';
export {Mode as CodeMirrorEditorMode} from './types';

export const AsyncCodeMirrorEditor = createAsyncComponent({
  load: () =>
    import(/* webpackChunkName: 'CodeMirrorEditor' */ './CodeMirrorEditor'),
  defer: DeferTiming.Mount,
});
